var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-table',{attrs:{"table-columns":_vm.tableColumns,"url":_vm.url,"operate":_vm.operate,"searchs":[],"form-fields":_vm.formFields,"permission":[]}})}
var staticRenderFns = []

export { render, staticRenderFns }